import { stringCompare } from '@mahawi/eshop-common/src/string-compare';
import {
  type IComparisonPortal,
  type IComparisonPortalCategory,
} from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
} from '../async-state';
import { type IComparisonPortalState } from './types';

export const preloadedState: IComparisonPortalState = {
  inProcess: false,
  portals: undefined,
  categories: undefined,
};

const comparisonPortalSlice = createSlice({
  name: 'ComparisonPortal',
  initialState: preloadedState,
  reducers: {
    loadComparisonPortalAll(state) {
      state.inProcess = true;
      state.portals = undefined;
    },
    loadComparisonPortalAllResponse: {
      reducer(state, action: { payload: { portals: IComparisonPortal[] } }) {
        state.inProcess = false;
        state.portals = action.payload.portals.sort(
          (a: IComparisonPortal, b: IComparisonPortal): number =>
            stringCompare(a.name, b.name),
        );
      },
      prepare(portals: IComparisonPortal[]) {
        return { payload: { portals } };
      },
    },
    loadComparisonPortalCategoriesAll(state) {
      state.inProcess = false;
      state.categories = undefined;
    },
    loadComparisonPortalCategoriesAllResponse: {
      reducer(
        state,
        action: { payload: { categories: IComparisonPortalCategory[] } },
      ) {
        state.inProcess = false;
        state.categories = action.payload.categories;
      },
      prepare(categories: IComparisonPortalCategory[]) {
        return { payload: { categories } };
      },
    },
    saveComparisonPortalCategory: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(categoryUUID: string, comparisonPortalCategoryUUID: string) {
        return { payload: { categoryUUID, comparisonPortalCategoryUUID } };
      },
    },
    saveComparisonPortalCategoryResponse: {
      reducer(state) {
        state.inProcess = false;
      },
      prepare(saved: boolean) {
        return { payload: { saved } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('ComparisonPortal'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  loadComparisonPortalAll,
  loadComparisonPortalAllResponse,
  loadComparisonPortalCategoriesAll,
  loadComparisonPortalCategoriesAllResponse,
  saveComparisonPortalCategory,
  saveComparisonPortalCategoryResponse,
} = comparisonPortalSlice.actions;
export default comparisonPortalSlice.reducer;
